import { t, useI18n } from "@bookingcom/lingojs-react";
import { UIFlightData } from "@flights/types";
import useATOL from "../../../../../../../hooks/useATOL";

const useAtolInfoController = (flight: UIFlightData) => {
  const i18n = useI18n();
  const { isATolProtectedFD } = useATOL();
  const isAtol = isATolProtectedFD(flight);

  return {
    header: i18n.trans(t("flights_atol_details_header")),
    atolText: isAtol ? i18n.trans(t("flights_atol_details_description")) : undefined
  };
};

export default useAtolInfoController;
